<section class="template-section">
  <h3>
    Add a new section
    @if (validationErrors?.missingDynamicSection) {
      <mat-icon
        class="required-icon error-circle"
        fontIcon="error_outlined"
        matTooltip="Add at least one section"
        matTooltipShowDelay="500"
      ></mat-icon>
    }
  </h3>
  <div class="row-wrapper">
    @if(allowedSectionTypes.templateSectionAllowed) {
      <button
        mat-button
        [disabled]="disabled"
        value="template"
        (click)="addSection.emit(SectionType.DocMergeTemplateSection)"
        matTooltip="Template section"
        matTooltipShowDelay="500"
      >
        <div class="button-content-wrapper">
          <mat-icon fontIcon="widgets" class="section-type-icon material-icons-outlined"></mat-icon>
          TEMPLATE
          <mat-icon>add</mat-icon>
        </div>
      </button>
    }

    @if(allowedSectionTypes.fileSectionAllowed) {
      <button
        mat-button
        value="file"
        [disabled]="disabled"
        (click)="addSection.emit(SectionType.File)"
        matTooltip="Add a file section"
        matTooltipShowDelay="500"
      >
        <div class="button-content-wrapper">
          <mat-icon fontIcon="home_storage" class="section-type-icon material-symbols-outlined"></mat-icon>
          FILE
          <mat-icon>add</mat-icon>
        </div>
      </button>
    }

    @if(allowedSectionTypes.fixedFileSectionAllowed) {
      <button
        mat-button
        value="fixed"
        [disabled]="disabled"
        (click)="addSection.emit(SectionType.FixedFile)"
        matTooltip="Fixed section"
        matTooltipShowDelay="500"
      >
        <div class="button-content-wrapper">
          <mat-icon fontIcon="insert_drive_file" class="section-type-icon material-icons-outlined"></mat-icon>
          FIXED
          <mat-icon>add</mat-icon>
        </div>
      </button>
    }

    @if (allowedSectionTypes.certificationSectionAllowed) {
      <button mat-button
              value="certification"
              [disabled]="disabled"
              (click)="addSection.emit(SectionType.Certification)"
              matTooltip="Certification section"
              matTooltipShowDelay="500">
        <div class="button-content-wrapper">
          <mat-icon fontIcon="workspace_premium" class="section-type-icon"></mat-icon>
          CERTIFICATION
          <mat-icon>add</mat-icon>
        </div>
      </button>
    }
  </div>
</section>
